module.exports = __webpack_public_path__ + "static/img/solutions-2.0d1585a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/solutions-2.jpeg
// module id = XNER
// module chunks = 1